import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private pending = 0;
  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();

  constructor() {
    // 🎁 Easter egg: Ctrl + Alt + S resets the spinner
    fromEvent<KeyboardEvent>(document, 'keydown').subscribe(e => {
      if (e.ctrlKey && e.altKey && e.key.toLowerCase() === 's') {
        this.reset();
        console.log('Spinner manually reset (ctrl+alt+s)');
      }
    });
  }

  show() {
    this.pending++;
    if (this.pending === 1) this.loadingSubject.next(true);
  }

  hide() {
    if (this.pending > 0) this.pending--;
    if (this.pending === 0) this.loadingSubject.next(false);
  }

  reset() {
    this.pending = 0;
    this.loadingSubject.next(false);
  }
}
